module.exports = "/images/ny-life1-4.jpg";